
import { useState } from "react";
import {Check, Copy} from "lucide-react";

const ReferralCode = ({ code, copied, setCopied }: { code: string, copied: boolean, setCopied: React.Dispatch<boolean> }) => {

    const copyToClipboard = async () => {
        try {
            const referralUrl = `${import.meta.env.VITE_SITE_URL}/signup?r=${code}`
            await navigator.clipboard.writeText(referralUrl);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        } catch (err) {
            // console.error("Kopyalama başarısız:", err);
        }
    };

    return (
        <div className="flex w-full md:w-1/2">
            <span className="flex-1 px-4 py-2 border rounded-l-md bg-gray-100 dark:bg-gray-700 dark:text-white dark:border-gray-600">{code}</span>
            <button
                onClick={(e) =>{
                    e.preventDefault();
                    copyToClipboard();
                }}
                className="px-4 py-2 text-white rounded-r-md transition bg-[#E5F4EA] hover:bg-[#D5E8DC] text-[#155231] dark:bg-[#2C3930] dark:hover:bg-[#2C3930]/90"
            >
                {copied ? <Check className="text-[#155231] dark:text-white w-5 h-5" /> : <Copy className="w-5 h-5 text-[#155231] dark:text-white" />}
            </button>
        </div>
    );
};

export default ReferralCode;
